import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { postApi } from "../api/postApi";
import { PAGINATION } from "../constants/common";

export const usePosts = (params) => {
  const queryKey = ["/posts", params];
  const queryClient = useQueryClient();

  const { data, isLoading, error } = useQuery({
    queryKey,
    queryFn: async () => await postApi.getAll(params),
  });

  const create = useMutation({
    mutationFn: async (body) => await postApi.create(body),
    onSuccess: () => queryClient.invalidateQueries({ queryKey }),
  });

  const update = useMutation({
    mutationFn: async ({ id, body }) => await postApi.update(id, body),
    onSuccess: () => queryClient.invalidateQueries({ queryKey }),
  });

  const remove = useMutation({
    mutationFn: async (id) => await postApi.remove(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey }),
  });

  return {
    data: data?.data || [],
    pagination: data?.pagination || PAGINATION,
    total: data?.pagination.total || 0,
    loading: isLoading,
    error,
    create,
    update,
    remove,
  };
};

export const usePost = (id) => {
  const queryKey = ["/post", id];
  const queryClient = useQueryClient();

  const { data, isLoading, error } = useQuery({
    queryKey,
    queryFn: async () => await postApi.getById(id),
    enabled: !!id && id !== "create",
  });

  const create = useMutation({
    mutationFn: async (body) => await postApi.create(body),
    onSuccess: () => queryClient.invalidateQueries({ queryKey }),
  });

  const update = useMutation({
    mutationFn: async ({ id, body }) => await postApi.update(id, body),
    onSuccess: () => queryClient.invalidateQueries({ queryKey }),
  });

  return {
    data,
    loading: isLoading,
    error,
    create,
    update,
  };
};
